import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DefaultFilter} from '@mominsamir/ngx-smart-table';

@Component({
    template: `
        <input
            [ngClass]="inputClass"
            [formControl]="inputControl"
            placeholder="{{ column.title }}"
            class="form-control"
            ngxOnlyNumber
            [integer]="isInteger"
        />
    `,
})
export class NumberInputComponent extends DefaultFilter implements OnInit, OnChanges {
    inputControl: FormControl = new FormControl(null);

    isInteger: boolean = true;

    constructor() {
        super();
    }

    ngOnInit() {
        if (this.query) {
            this.inputControl.setValue(+this.query);
        }
        this.inputControl.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(this.delay))
            .subscribe((value: string) => {
                if (this.inputControl.invalid) {
                    this.inputControl.setValue(null, {emitEvent: false});
                    this.query = null;
                    this.setFilter();
                } else if (this.inputControl.status === 'VALID') {
                    this.query = value;
                    this.setFilter();
                }
            });
        this.isInteger = this.column.filter.config?.isInteger ?? true;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.query) {
            this.query = changes.query.currentValue;
            this.inputControl.setValue(this.inputControl.value);
        }
    }
}
